import { green } from '@ant-design/colors';
import {
  AppstoreOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined,
  FilterOutlined,
  SettingOutlined,
  TableOutlined
} from '@ant-design/icons';
import {
  Button,
  Col,
  Empty,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tabs,
  Tooltip,
  Typography,
  Upload,
  message
} from 'antd';
import Text from 'antd/lib/typography/Text';
import { isEmpty } from 'lodash';
import lodashClonedeep from 'lodash/cloneDeep';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { Label, SubSubtitleStart, Subtitle } from '../../components';
import CurrencyInputCustom from '../../components/CurrencyInputCustom';
import TableAndFilters from '../../components/TableAndFilters';
import { CONFIG, TIPOS_VEHICULO } from '../../constants';
import FranquiciaSelect from '../../modelos/admins/componentes/FranquiciaSelect';
import {
  currencyToNumber,
  errorHandler,
  getDescripcionFranquicia,
  getTipoValidacion,
  numberToCurrency,
  renderPorcentaje
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';
import PlanControlProductoModal from '../autorizacion/PlanControlProductoModal';

const { TabPane } = Tabs;
const formDialogLayout = {
  labelCol: {
    xs: { span: 12 }
  },
  wrapperCol: {
    xs: { span: 12 }
  }
};

const formatosAceptados =
  '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const PlanConfig = ({
  open,
  onCancel,
  onOk,
  plan = {},
  disabledProductoCerrado,
  idAseguradora
}) => {
  const [form] = Form.useForm();
  const [monedas, setMonedas] = useState([]);
  const [monedaSelected, setMonedaSelected] = useState();
  const [formTasaVisible, setFormTasaVisible] = useState(false);
  const [errorTipos, setErrorTipos] = useState(false);
  const [loadingVerificar, setLoadingVerificar] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  // const [insertarIntermedio, setInsertarIntermedio] = useState(false);
  // const [idActual, setIdActual] = useState(false);
  const insertarIntermedio = false;
  const idActual = false;
  const [tipoActual, setTipoActual] = useState('AUTOMOVIL');
  const [modalForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [modalFormCostos] = Form.useForm();
  const [modalCostosVisible, setModalCostosVisible] = useState(false);
  const [montosVisible, setMontosVisible] = useState(false);
  const [parametrosVisible, setParametrosVisible] = useState(false);
  const [formMontosVisible, setFormMontosVisible] = useState(false);
  const [formMontos] = Form.useForm();
  const [formParametros] = Form.useForm();
  const [dataMontos, setDataMontos] = useState([]);
  const [vigencias, setVigencias] = useState([]);
  const [selectedRowKeysMonto, setSelectedRowKeysMonto] = useState([]);
  const [dataCostos, setDataCostos] = useState();
  const [dataProductoParametro, setDataProductoParametros] = useState();
  const [productos, setProductos] = useState([]);
  const [objetos, setObjetos] = useState([]);
  const [riesgos, setRiesgos] = useState([]);
  const [tiposRiesgo, setTiposRiesgo] = useState([]);

  const tableRefs = useRef({});

  const { Option } = Select;

  const columnsMontoCuota = [
    {
      title: 'Vigencia',
      dataIndex: ['id_vigencia_pago'],
      key: ['id_vigencia_pago'],
      align: 'right',
      render: (value) => (
        <Typography.Text style={{ whiteSpace: 'nowrap' }}>
          {vigencias.length > 0 && value
            ? vigencias.find((item) => item.id === value).descripcion
            : ''}
        </Typography.Text>
      )
    },
    {
      title: 'Cantidad Cuotas',
      dataIndex: ['numero_cuotas'],
      key: ['numero_cuotas'],
      align: 'right'
    },
    {
      title: 'Monto',
      dataIndex: ['monto_cuota'],
      key: ['monto_cuota'],
      align: 'right',
      render: (value) => (
        <Typography.Text style={{ whiteSpace: 'nowrap' }}>
          {formatoMonedaGenerico(monedaSelected, value)}
        </Typography.Text>
      )
    }
  ];

  const prepareData = (values) => {
    const { datosExtra } = values;
    if (datosExtra) {
      datosExtra.sumaAsegurada = Number(datosExtra.sumaAsegurada || '0');
    }
    const dataCostoMinimoTasaPura = form.getFieldValue(
      'costo_minimo_tasa_pura'
    );
    const dataCostosMinimosTablaTasas = form.getFieldValue(
      'costos_minimos_tabla_tasas'
    );
    const preparedData = {
      ...values,
      monto_total: Number(values.monto_total || '0'),
      moneda: monedaSelected,
      datosExtra,
      costo_minimo: dataCostoMinimoTasaPura
        ? { costo: dataCostoMinimoTasaPura }
        : dataCostosMinimosTablaTasas,
      montos: dataMontos,
      json_producto_sistema_core: {
        sebaot_codigo_seccion:
          dataProductoParametro?.producto?.split('-')[1] || null,
        sebaot_codigo_producto:
          dataProductoParametro?.producto?.split('-')[0] || null,
        sebaot_objeto: dataProductoParametro?.objeto || null,
        sebaot_riesgo: dataProductoParametro?.riesgo || null,
        sebaot_tipo_riesgo: dataProductoParametro?.tipo_riesgo || null
      }
    };
    if (values.tasa_tipo === 'tasa_config') {
      preparedData.tasa_pura = null;
    }
    if (values.tasa_tipo === 'tasa_pura') {
      preparedData.tasa_config = null;
    }

    return preparedData;
  };

  const onFinish = (values) => {
    onOk(prepareData(values));
  };

  const fetchMonedas = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/moneda`);
      setMonedas(monedasResponse.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  const fetchVigencias = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/vigencia`);
      setVigencias(monedasResponse.data?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  const fetchListSebaot = useCallback(
    async (
      resource,
      {
        hostSebaot,
        puertoSebaot,
        userSebaot,
        passSebaot,
        hostSebaotPagos,
        puertoSebaotPagos,
        userSebaotPagos,
        passSebaotPagos,
        userSebaotPagosLote,
        passSebaotPagosLote
      }
    ) => {
      return instanceRef.instance.get(`/sebaot/${resource}`, {
        params: {
          hostSebaot,
          puertoSebaot,
          userSebaot,
          passSebaot,
          hostSebaotPagos,
          puertoSebaotPagos,
          userSebaotPagos,
          passSebaotPagos,
          userSebaotPagosLote,
          passSebaotPagosLote,
          idAseguradora
        }
      });
    },
    [idAseguradora]
  );

  const loadAseguradora = async (id) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(`/aseguradoras/${id}`);
      setLoading(false);
      if (response.data?.data) {
        const {
          sebaot_tiene,
          sebaot_host,
          sebaot_puerto,
          sebaot_user,
          sebaot_pass,
          sebaot_host_pagos,
          sebaot_puerto_pagos,
          sebaot_user_pagos,
          sebaot_pass_pagos,
          sebaot_user_pagos_lote,
          sebaot_pass_pagos_lote
          // aseguradoraEmpresa: { sebaot_codigo_agente, fecha_inicio, fecha_fin }
        } = response.data.data;
        if (sebaot_tiene) {
          loadSebaotData({
            hostSebaot: sebaot_host,
            puertoSebaot: sebaot_puerto,
            userSebaot: sebaot_user,
            passSebaot: sebaot_pass,
            hostSebaotPagos: sebaot_host_pagos,
            puertoSebaotPagos: sebaot_puerto_pagos,
            userSebaotPagos: sebaot_user_pagos,
            passSebaotPagos: sebaot_pass_pagos,
            userSebaotPagosLote: sebaot_user_pagos_lote,
            passSebaotPagosLote: sebaot_pass_pagos_lote
          });
        }
      }
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const onChangeActiveTab = (tab) => {
    setTipoActual(tab);
  };

  const uploadFile = async (file, tipo, idPlan, setter, loadingFile) => {
    try {
      loadingFile(true);
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('tipo', tipo);
      formData.append('idPlan', idPlan);
      const response = await instanceRef.instance.post(
        `archivos/tasas`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      setter(response.data.data);
      loadingFile(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        Modal.error({
          maskClosable: true,
          closable: true,
          width: 1000,
          title: error?.response?.data?.message.mensaje,
          content: (
            <>
              {error?.response?.data?.message?.errorList?.map((item, index) => (
                <Fragment key={index}>
                  <span>
                    ID: {item.id}, Error: {item.error}
                  </span>
                  <br />
                </Fragment>
              ))}
            </>
          )
        });
      } else {
        message.error('Verificar el formato del archivo');
      }
      loadingFile(false);
    }
  };

  const onSelectChange = (newSelectedRowKeys, tipoActualParam) => {
    setRowSelection((actual) => ({
      ...actual,
      [tipoActualParam]: {
        ...actual[tipoActualParam],
        selectedRowKeys: newSelectedRowKeys
      }
    }));
  };
  const hasSelected = rowSelection[tipoActual]?.selectedRowKeys?.length > 0;

  const onFileSuccess = async () => {
    await instanceRef.instance.get(`/configtasa`, {
      params: {
        idPlan: plan.idPlan,
        tipo: tipoActual,
        current: 1,
        pageSize: 20,
        showSizeChanger: true
      }
    });
    const tableRef = tableRefs.current[tipoActual];
    tableRef.reload();
    form.setFieldsValue({ tasa_config: true });
    setErrorTipos({ ...errorTipos, [tipoActual]: false });
  };

  const loadSebaotData = async (params) => {
    try {
      setLoading(true);
      const responseProductos = await fetchListSebaot('consultarDatos', {
        ...params,
        idAseguradora
      });
      if (responseProductos.data.data.productos) {
        setProductos(responseProductos.data.data.productos);
        setObjetos(responseProductos.data.data.objetos);
        setRiesgos(responseProductos.data.data.riesgos);
        setTiposRiesgo(responseProductos.data.data.tiposRiesgo);

        setLoading(false);
        return true;
      }
      message.error('Verificar parámetros de Sebaot');
    } catch (error) {
      message.error('Verificar parámetros de Sebaot');
    }
    setLoading(false);
    return false;
  };

  const tieneConfigurado = async (params) => {
    try {
      const tiene = await instanceRef.instance.get(`/configtasa/tiene`, {
        params
      });
      return tiene;
    } catch (_) {
      return false;
    }
  };

  const verificarInicial = useCallback(async () => {
    setErrorTipos({});
    setLoadingVerificar(true);
    const tiene = await tieneConfigurado({
      idPlan: plan.idPlan
    });
    setLoadingVerificar(false);

    if (tiene && tiene.data.data) {
      const tiposConfigurados = tiene.data.data.map(
        (item) => item.tipo_clasificacion
      );

      const errores = {};
      TIPOS_VEHICULO.forEach((item) => {
        errores[item] = !tiposConfigurados.includes(item);
      });
      setErrorTipos(errores);
    }
  }, [plan.idPlan]);

  const onOkTasa = async () => {
    setErrorTipos({});
    setLoadingVerificar(true);
    const tiene = await tieneConfigurado({
      idPlan: plan.idPlan
    });
    setLoadingVerificar(false);

    if (tiene.data.data) {
      const tiposConfigurados = tiene.data.data.map(
        (item) => item.tipo_clasificacion
      );
      const verificarTodos = TIPOS_VEHICULO.every((elem) =>
        tiposConfigurados.includes(elem)
      );
      const errores = {};
      TIPOS_VEHICULO.forEach((item) => {
        errores[item] = !tiposConfigurados.includes(item);
      });
      setErrorTipos(errores);
      if (verificarTodos) {
        setFormTasaVisible(false);
        form.validateFields(['tasa_tipo']);
        return;
      }
    }
    message.error('Verificar rangos de todos los tipos');
  };

  const onCancelTasa = () => {
    setFormTasaVisible(false);
  };

  const onFinishRango = (values) => {
    const tasaConfig = form.getFieldValue('tasa_config');

    const idNuevo = tasaConfig[tipoActual].length + 1;
    const indexRangoModificado = tasaConfig[tipoActual].findIndex(
      (item) => item.id === idActual
    );
    if (insertarIntermedio) {
      tasaConfig[tipoActual].splice(indexRangoModificado + 1, 0, {
        tipo: tipoActual,
        ...values,
        monto_min: currencyToNumber(values.monto_min, monedaSelected),
        monto_max: currencyToNumber(values.monto_max, monedaSelected)
      });
      tasaConfig[tipoActual].forEach((_, index) => {
        tasaConfig[tipoActual][index].id = index + 1;
      });
    } else if (indexRangoModificado === tasaConfig[tipoActual].length - 1) {
      // Si se está editando y es el último registro
      tasaConfig[tipoActual][indexRangoModificado] = {
        ...tasaConfig[tipoActual][indexRangoModificado],
        tipo: tipoActual,
        ...values,
        monto_min: currencyToNumber(values.monto_min, monedaSelected),
        monto_max: currencyToNumber(values.monto_max, monedaSelected)
      };
      // Si el monto_max está definido, se inserta una nueva fila automáticamente para cubrir hasta infinito
      if (
        values.monto_max != null &&
        currencyToNumber(values.monto_max, monedaSelected) !== 0
      ) {
        tasaConfig[tipoActual] = [
          ...tasaConfig[tipoActual],
          {
            id: idNuevo,
            tipo: tipoActual,
            monto_min: currencyToNumber(values.monto_max, monedaSelected) + 1,
            monto_max: null,
            origen: {
              nuevo: 0,
              representante: 0,
              volantecambiado: 0,
              importacion: 0
            }
          }
        ];
      }
    } else {
      tasaConfig[tipoActual][indexRangoModificado] = {
        ...tasaConfig[tipoActual][indexRangoModificado],
        ...values,
        monto_min: currencyToNumber(values.monto_min, monedaSelected),
        monto_max: currencyToNumber(values.monto_max, monedaSelected)
      };
    }
    form.setFieldsValue({ tasa_config: tasaConfig });
    setModalVisible(false);
  };

  const onFinishCostosMinimos = (values) => {
    const costosMinimos = dataCostos || {};
    // form.getFieldValue('costos_minimos_tabla_tasas') || {};
    costosMinimos[tipoActual] = values[tipoActual];
    form.setFieldsValue({ costos_minimos_tabla_tasas: costosMinimos });
    setDataCostos(costosMinimos);

    setModalCostosVisible(false);
  };

  const normalizePorcentaje = (value) => {
    if (Number(value) > 100) {
      return 100;
    }
    if (Number(value) < 0) {
      return 0;
    }
    return Number(value);
  };

  const onOkMontos = () => {
    setMontosVisible(false);
    form.setFieldsValue({ montos: dataMontos });
    // form.validateFields(['montos']);
  };

  const onCancelMontos = () => {
    setMontosVisible(false);
  };

  const onFinishMontos = () => {
    handleAddRow();
    setFormMontosVisible(false);
  };

  const onFinishParametrosProducto = (values) => {
    setDataProductoParametros(values);
    formParametros.setFieldsValue({
      producto: values?.producto || null,
      objeto: values?.objeto || null,
      riesgo: values?.riesgo || null,
      tipo_riesgo: values?.tipo_riesgo || null
    });
    setParametrosVisible(false);
  };

  const eliminarMontos = () => {
    const newDataMontos = dataMontos.filter(
      (item) =>
        (item.id && !selectedRowKeysMonto.includes(item.id)) ||
        (item.key && !selectedRowKeysMonto.includes(item.key))
    );
    setSelectedRowKeysMonto([...selectedRowKeysMonto]);
    form.setFieldsValue({ montos: newDataMontos });
    setDataMontos(newDataMontos);
  };

  const onSelectChangeMontos = (newSelectedRowKeys) => {
    setSelectedRowKeysMonto([...newSelectedRowKeys]);
  };
  const rowSelectionMonto = {
    selectedRowKeys: selectedRowKeysMonto,
    onChange: onSelectChangeMontos
  };
  const hasSelectedMontos = selectedRowKeysMonto?.length > 0;

  const handleAddRow = () => {
    const montosData = formMontos.getFieldsValue();
    const newRow = {
      key: Date.now(),
      ...montosData,
      id: null,
      id_plan: plan.idPlan,
      row: Number(dataMontos.length + 1)
    };
    setDataMontos([...dataMontos, newRow]);
  };

  const handleClickMontos = () => {
    if (vigencias.length === 0) {
      fetchVigencias();
    }
    setMontosVisible(true);
  };

  const handleClickParametrosProducto = () => {
    setParametrosVisible(true);
  };

  const configInicial = useMemo(() => {
    const config = {};
    TIPOS_VEHICULO.forEach((item) => {
      config[item] = [
        {
          id: 1,
          tipo: item,
          monto_min: 1,
          monto_max: null,
          origen: {
            nuevo: 0,
            representante: 0,
            volantecambiado: 0,
            importacion: 0
          }
        }
      ];
    });
    return config;
  }, []);

  const configCostoMinimoInicial = useMemo(() => {
    const costoMinimo = {};
    TIPOS_VEHICULO.forEach((item) => {
      costoMinimo[item] = {
        nuevo: 0,
        representante: 0,
        volantecambiado: 0,
        importacion: 0
      };
    });
    return costoMinimo;
  }, []);

  useEffect(() => {
    if (form && plan) {
      const values = { ...plan };
      if (plan.producto_cerrado) {
        if (plan.tasa_pura) {
          values.tasa_tipo = 'tasa_pura';
          values.costo_minimo_tasa_pura = plan.costo_minimo?.costo || 0;
        } else {
          values.tasa_tipo = 'tasa_config';
          values.costos_minimos_tabla_tasas =
            plan.costo_minimo || configCostoMinimoInicial;
          values.costo_minimo_tasa_pura = null;
        }
      } else {
        values.tasa_config = configInicial;
        values.costos_minimos_tabla_tasas = configCostoMinimoInicial;
        values.producto_cerrado = false;
      }
      const parametros = values.json_producto_sistema_core;
      formParametros.setFieldsValue({
        producto: parametros?.sebaot_codigo_producto
          ? `${parametros?.sebaot_codigo_producto}-${parametros?.sebaot_codigo_seccion}`
          : null,
        objeto: parametros?.sebaot_objeto || null,
        riesgo: parametros?.sebaot_riesgo || null,
        tipo_riesgo: parametros?.sebaot_tipo_riesgo || null
      });
      setDataCostos(values.costos_minimos_tabla_tasas);
      form.setFieldsValue(values);
    }
  }, [configCostoMinimoInicial, configInicial, form, plan, formParametros]);

  useEffect(() => {
    setMonedaSelected(plan.moneda);
    setDataMontos(plan.montos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plan]);

  useEffect(() => {
    fetchMonedas();
  }, []);

  useEffect(() => {
    const rowSelectionConfig = {};
    TIPOS_VEHICULO.forEach((item) => {
      rowSelectionConfig[item] = {
        selectedRowKeys: [],
        preserveSelectedRowKeys: true,
        onChange: (newSelectedRowKeys) =>
          onSelectChange(newSelectedRowKeys, item)
      };
    });
    setRowSelection(rowSelectionConfig);
  }, []);

  useEffect(() => {
    if (plan.idPlan) {
      verificarInicial();
    }
  }, [plan.idPlan, verificarInicial]);

  useEffect(() => {
    if (idAseguradora) {
      loadAseguradora(idAseguradora);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAseguradora]);

  return (
    <>
      {plan && (
        <>
          <Modal
            forceRender
            title="Configurar Plan"
            open={open}
            width={1000}
            afterClose={() => {
              form.resetFields();
              setFormTasaVisible(false);
            }}
            onCancel={() => {
              onCancel();
            }}
            okButtonProps={{
              form: 'planEditor',
              htmlType: 'submit',
              disabled: formTasaVisible || montosVisible
            }}
          >
            <div style={{ textAlign: 'left' }}>
              <>
                <Form
                  {...formDialogLayout}
                  initialValues={plan}
                  scrollToFirstError
                  form={form}
                  name="planEditor"
                  id="planEditor"
                  autoComplete="off"
                  layout="horizontal"
                  onFinish={onFinish}
                >
                  {!(formTasaVisible || montosVisible) &&
                    !disabledProductoCerrado && (
                      <>
                        <Form.Item
                          label="Producto cerrado"
                          name="producto_cerrado"
                          rules={[{ required: true }]}
                          valuePropName="checked"
                        >
                          <Switch checkedChildren="Si" unCheckedChildren="No" />
                        </Form.Item>
                        <Form.Item noStyle shouldUpdate>
                          {({ getFieldValue }) => {
                            if (getFieldValue('producto_cerrado')) {
                              return (
                                <Form.Item
                                  label="Aplica fórmula"
                                  name="aplica_formula"
                                  valuePropName="checked"
                                >
                                  <Switch
                                    checkedChildren="Si"
                                    unCheckedChildren="No"
                                  />
                                </Form.Item>
                              );
                            }
                            return null;
                          }}
                        </Form.Item>
                        <Form.Item noStyle shouldUpdate>
                          <Form.Item
                            label="Aplica descuento/recargo"
                            name="aplica_descuento"
                            valuePropName="checked"
                          >
                            <Switch
                              checkedChildren="Si"
                              unCheckedChildren="No"
                            />
                          </Form.Item>
                        </Form.Item>
                        <Form.Item noStyle shouldUpdate>
                          {({ getFieldValue }) => {
                            if (getFieldValue('producto_cerrado')) {
                              return (
                                <Form.Item
                                  label="Tipo de tasa"
                                  name="tasa_tipo"
                                  rules={[{ required: true }]}
                                >
                                  <Radio.Group>
                                    <Space direction="vertical">
                                      <Radio value="tasa_pura">Tasa pura</Radio>
                                      {plan.producto?.codigo === 1 && (
                                        <Radio value="tasa_config">
                                          Tabla de tasas
                                        </Radio>
                                      )}
                                    </Space>
                                  </Radio.Group>
                                </Form.Item>
                              );
                            }
                            return null;
                          }}
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate>
                          {({ getFieldValue }) => {
                            if (getFieldValue('producto_cerrado')) {
                              if (getFieldValue('tasa_tipo') === 'tasa_pura') {
                                return (
                                  <>
                                    <Form.Item
                                      label="Tasa pura"
                                      name="tasa_pura"
                                      rules={[{ required: true }]}
                                    >
                                      <Input
                                        style={{
                                          width: 200
                                        }}
                                        placeholder="0"
                                        min={0}
                                        max={100}
                                        step="any"
                                        type="number"
                                        suffix="%"
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      label="Costo Mínimo"
                                      name="costo_minimo_tasa_pura"
                                      normalize={(value) =>
                                        currencyToNumber(value, monedaSelected)
                                      }
                                    >
                                      <CurrencyInputCustom
                                        moneda={monedaSelected}
                                        autoFocus
                                        bordered
                                      />
                                    </Form.Item>
                                  </>
                                );
                              }
                              if (
                                getFieldValue('tasa_tipo') === 'tasa_config'
                              ) {
                                return (
                                  <div style={{ textAlign: 'center' }}>
                                    <Form.Item
                                      label="Tasa de configuraciones"
                                      name="tasa_config"
                                      noStyle
                                    >
                                      <Button
                                        type="primary"
                                        ghost
                                        htmlType="button"
                                        icon={<TableOutlined />}
                                        onClick={() => setFormTasaVisible(true)}
                                      >
                                        Configurar tasas
                                      </Button>
                                    </Form.Item>
                                    <br />
                                    <br />
                                  </div>
                                );
                              }
                            }

                            return null;
                          }}
                        </Form.Item>

                        <Form.Item noStyle shouldUpdate>
                          <>
                            <Form.Item
                              label="Monto contado final"
                              name="monto_contado_final"
                              // rules={[{ required: true }]}
                              normalize={(value) => {
                                if (value !== 0) {
                                  return currencyToNumber(
                                    value,
                                    monedaSelected
                                  );
                                }
                                return null;
                              }}
                            >
                              <CurrencyInputCustom
                                moneda={monedaSelected}
                                autoFocus
                                bordered
                              />
                            </Form.Item>

                            <Form.Item
                              label="Monto cuota final"
                              rules={[{ required: true }]}
                            >
                              <Button
                                type="primary"
                                ghost
                                htmlType="button"
                                icon={<TableOutlined />}
                                onClick={handleClickMontos}
                              >
                                Configurar Montos
                              </Button>
                            </Form.Item>
                            <Form.Item
                              label="Producto Sistema Core"
                              name="json_producto_sistema_core"
                            >
                              <Button
                                type="primary"
                                ghost
                                htmlType="button"
                                icon={<AppstoreOutlined />}
                                onClick={handleClickParametrosProducto}
                              >
                                Configurar Parámetros
                              </Button>
                            </Form.Item>
                          </>
                        </Form.Item>
                      </>
                    )}
                  {formTasaVisible && (
                    <div>
                      <>
                        <Tabs
                          activeKey={tipoActual}
                          size="small"
                          onChange={(tab) => onChangeActiveTab(tab)}
                        >
                          {TIPOS_VEHICULO.map((item) => {
                            const columnsCostoMinimo = [
                              {
                                title: '',
                                key: [''],
                                align: 'right',
                                render: () => 'Costos Mínimos'
                              },

                              {
                                title: 'Nuevo',
                                dataIndex: ['nuevo'],
                                key: ['nuevo'],
                                align: 'right',
                                render: (value) => (
                                  <Typography.Text
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {formatoMonedaGenerico(
                                      monedaSelected,
                                      value
                                    )}
                                  </Typography.Text>
                                )
                              },
                              {
                                title: 'Representante',
                                dataIndex: ['representante'],
                                key: ['representante'],
                                align: 'right',
                                render: (value) => (
                                  <Typography.Text
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {formatoMonedaGenerico(
                                      monedaSelected,
                                      value
                                    )}
                                  </Typography.Text>
                                )
                              },
                              {
                                title: 'Volante cambiado',
                                dataIndex: ['volantecambiado'],
                                key: ['volantecambiado'],
                                align: 'right',
                                render: (value) => (
                                  <Typography.Text
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {formatoMonedaGenerico(
                                      monedaSelected,
                                      value
                                    )}
                                  </Typography.Text>
                                )
                              },
                              {
                                title: 'Importación',
                                dataIndex: ['importacion'],
                                key: ['importacion'],
                                align: 'right',
                                render: (value) => (
                                  <Typography.Text
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {formatoMonedaGenerico(
                                      monedaSelected,
                                      value
                                    )}
                                  </Typography.Text>
                                )
                              },
                              {
                                title: 'Acciones',
                                key: 'action',
                                width: '10px',
                                align: 'left',
                                render: (_, record) => {
                                  const datos = {};
                                  datos[tipoActual] = record;
                                  return (
                                    <Space size="small">
                                      <Tooltip title="Configurar">
                                        <Button
                                          icon={<SettingOutlined />}
                                          type="text"
                                          size="middle"
                                          onClick={() => {
                                            setModalCostosVisible(true);
                                            modalFormCostos.setFieldsValue(
                                              datos
                                            );
                                          }}
                                        />
                                      </Tooltip>
                                    </Space>
                                  );
                                }
                              }
                            ];
                            const columns = [
                              {
                                title: 'Nro',
                                dataIndex: ['id'],
                                key: ['id'],
                                align: 'right',
                                render: (_, a, index) => index + 1
                              },
                              {
                                title: 'Desde',
                                dataIndex: ['monto_min'],
                                key: ['monto_min'],
                                align: 'right',
                                render: (value) => (
                                  <Typography.Text
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {formatoMonedaGenerico(
                                      monedaSelected,
                                      value
                                    )}
                                  </Typography.Text>
                                )
                              },
                              {
                                title: 'Hasta',
                                dataIndex: ['monto_max'],
                                key: ['monto_max'],
                                align: 'right',
                                render: (value) => (
                                  <Typography.Text
                                    style={{ whiteSpace: 'nowrap' }}
                                  >
                                    {value === null ||
                                    currencyToNumber(value, monedaSelected) ===
                                      0
                                      ? '-'
                                      : formatoMonedaGenerico(
                                          monedaSelected,
                                          value
                                        )}
                                  </Typography.Text>
                                )
                              },
                              {
                                title: 'Nuevo',
                                dataIndex: ['tasas', 'origen', 'nuevo'],
                                key: ['tasas', 'origen', 'nuevo'],
                                align: 'right',
                                render: renderPorcentaje
                              },
                              {
                                title: 'Representante',
                                dataIndex: ['tasas', 'origen', 'representante'],
                                key: ['tasas', 'origen', 'representante'],
                                align: 'right',
                                render: renderPorcentaje
                              },
                              {
                                title: 'Volante cambiado',
                                dataIndex: [
                                  'tasas',
                                  'origen',
                                  'volantecambiado'
                                ],
                                key: ['tasas', 'origen', 'volantecambiado'],
                                align: 'right',
                                render: renderPorcentaje
                              },
                              {
                                title: 'Importación',
                                dataIndex: ['tasas', 'origen', 'importacion'],
                                key: ['tasas', 'origen', 'importacion'],
                                align: 'right',
                                render: renderPorcentaje
                              }
                            ];

                            const dataSourceCostos = dataCostos[item];
                            return (
                              <TabPane
                                tab={
                                  <span>
                                    <>
                                      {isEmpty(errorTipos) ||
                                      errorTipos[item] ? (
                                        <Tooltip title="Verificar rangos y porcentajes">
                                          <ExclamationCircleOutlined />
                                        </Tooltip>
                                      ) : (
                                        <CheckCircleOutlined
                                          style={{ color: green.primary }}
                                        />
                                      )}
                                    </>

                                    {item}
                                  </span>
                                }
                                key={item}
                              >
                                <SubSubtitleStart>
                                  Costos mínimos
                                </SubSubtitleStart>
                                <Table
                                  scroll
                                  style={{ width: 'fit-content' }}
                                  bordered
                                  dataSource={[dataSourceCostos]}
                                  columns={columnsCostoMinimo}
                                  pagination={false}
                                  rowKey={(record) => record?.id}
                                  size="small"
                                />

                                <br />
                                <SubSubtitleStart>Tasas</SubSubtitleStart>
                                <div
                                  style={{
                                    marginBottom: 16
                                  }}
                                >
                                  <Space>
                                    <Upload
                                      showUploadList={false}
                                      customRequest={(e) =>
                                        uploadFile(
                                          e,
                                          tipoActual,
                                          plan.idPlan,
                                          onFileSuccess,
                                          setLoading
                                        )
                                      }
                                      accept={formatosAceptados}
                                    >
                                      <Button
                                        type="primary"
                                        ghost
                                        icon={<FileExcelOutlined />}
                                        disabled={loading}
                                      >
                                        Cargar planilla
                                      </Button>
                                    </Upload>
                                  </Space>
                                  <span
                                    style={{
                                      marginLeft: 8
                                    }}
                                  >
                                    {hasSelected
                                      ? `Seleccionados ${rowSelection[tipoActual].selectedRowKeys.length} items`
                                      : ''}
                                  </span>
                                </div>

                                <TableAndFilters
                                  ref={(element) => {
                                    tableRefs.current[tipoActual] = element;
                                  }}
                                  scroll
                                  rowSelection={rowSelection[tipoActual]}
                                  style={{ width: 'fit-content' }}
                                  bordered
                                  url={`/configtasa?idPlan=${plan.idPlan}&tipo=${tipoActual}`}
                                  columns={columns}
                                  rowKey={(record) => record.id}
                                  showTable
                                  size="small"
                                  locale={{
                                    emptyText: (
                                      <>
                                        <Empty
                                          className="ant-empty-small"
                                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        />
                                      </>
                                    )
                                  }}
                                />
                              </TabPane>
                            );
                          })}
                        </Tabs>
                      </>

                      <br />
                      <Space>
                        <Button
                          type="primary"
                          htmlType="button"
                          loading={loadingVerificar}
                          onClick={() => onOkTasa()}
                        >
                          Aceptar
                        </Button>
                        <Button
                          htmlType="button"
                          onClick={() => onCancelTasa()}
                        >
                          Cancelar
                        </Button>
                      </Space>
                    </div>
                  )}
                  {!(formTasaVisible || montosVisible) && (
                    <>
                      {plan.producto?.codigo !== 1 && (
                        <>
                          {monedas && monedaSelected && (
                            <>
                              <Row gutter={[16, 0]}>
                                <Col
                                  xs={24}
                                  md={12}
                                  style={{ textAlign: 'end' }}
                                >
                                  <Label>Moneda: </Label>
                                </Col>
                                <Col
                                  xs={24}
                                  md={12}
                                  style={{ textAlign: 'start' }}
                                >
                                  <Label>{monedaSelected.descripcion}</Label>
                                </Col>
                              </Row>
                            </>
                          )}
                          <Form.Item
                            label="Suma asegurada"
                            name="monto_total"
                            normalize={(value) =>
                              currencyToNumber(value, monedaSelected)
                            }
                          >
                            <CurrencyInputCustom
                              moneda={monedaSelected}
                              autoFocus
                              bordered
                            />
                          </Form.Item>
                        </>
                      )}
                      {plan.producto?.codigo === 1 && (
                        <>
                          <Subtitle>Datos para simulación</Subtitle>
                          {monedas && monedaSelected && (
                            <>
                              <Row gutter={[16, 0]}>
                                <Col
                                  xs={24}
                                  md={12}
                                  style={{ textAlign: 'end' }}
                                >
                                  <Label>Moneda: </Label>
                                </Col>
                                <Col
                                  xs={24}
                                  md={12}
                                  style={{ textAlign: 'start' }}
                                >
                                  <Label>{monedaSelected.descripcion}</Label>
                                </Col>
                              </Row>
                            </>
                          )}
                          <Form.Item
                            label="Suma Asegurada"
                            name={['datosExtra', 'sumaAsegurada']}
                            normalize={(value) =>
                              currencyToNumber(value, monedaSelected)
                            }
                          >
                            <CurrencyInputCustom
                              moneda={monedaSelected}
                              autoFocus
                              bordered
                            />
                          </Form.Item>
                          <Form.Item
                            label="Vehículo 0 km"
                            name={['datosExtra', 'cerokm']}
                          >
                            <Radio.Group>
                              <Space>
                                <Radio value>Si</Radio>
                                <Radio value={false}>No</Radio>
                              </Space>
                            </Radio.Group>
                          </Form.Item>
                          <Form.Item
                            label={
                              <span style={{ whiteSpace: 'normal' }}>
                                Importación directa (vía Chile, USA y Otros)
                              </span>
                            }
                            name={['datosExtra', 'importacion']}
                          >
                            <Radio.Group>
                              <Space>
                                <Radio value>Si</Radio>
                                <Radio value={false}>No</Radio>
                              </Space>
                            </Radio.Group>
                          </Form.Item>
                          <Form.Item
                            label="Volante cambiado"
                            name={['datosExtra', 'volante_cambiado']}
                          >
                            <Radio.Group>
                              <Space>
                                <Radio value>Si</Radio>
                                <Radio value={false}>No</Radio>
                              </Space>
                            </Radio.Group>
                          </Form.Item>
                          <Form.Item
                            label="Plazas"
                            name={['datosExtra', 'submodelo', 'plazas']}
                          >
                            <InputNumber />
                          </Form.Item>
                          <Form.Item
                            label="Tipo"
                            name={[
                              'datosExtra',
                              'submodelo',
                              'descripcion_tipo'
                            ]}
                          >
                            <Radio.Group>
                              <Space direction="vertical">
                                <Radio value="AUTOMOVIL">AUTOMÓVIL</Radio>
                                <Radio value="CAMIONETA_PICKUP">
                                  CAMIONETA PICKUP
                                </Radio>
                                <Radio value="CAMIONETA">CAMIONETA</Radio>
                                <Radio value="FURGON">FURGÓN</Radio>
                                <Radio value="CAMION">CAMIÓN</Radio>
                                <Radio value="BUS">BUS</Radio>
                                <Radio value="REMOLQUE">REMOLQUE</Radio>
                                <Radio value="TRACTOCAMION">TRACTOCAMIÓN</Radio>
                                <Radio value="SEMIREMOLQUE">SEMIREMOLQUE</Radio>
                                <Radio value="MAQUINARIAS_AGRICOLAS">
                                  MAQUINARIAS AGRÍCOLAS
                                </Radio>
                                <Radio value="MOTO">MOTO</Radio>
                                <Radio value="EMBARCACION">EMBARCACIÓN</Radio>
                                <Radio value="AMBULANCIA">AMBULANCIA</Radio>
                                <Radio value="MAQUINARIAS">MAQUINARIAS</Radio>
                              </Space>
                            </Radio.Group>
                          </Form.Item>
                        </>
                      )}
                    </>
                  )}
                  {montosVisible && (
                    <div>
                      <>
                        <br />
                        <div
                          style={{
                            marginBottom: 16
                          }}
                        >
                          <Space>
                            <Button
                              onClick={() => setFormMontosVisible(true)}
                              type="primary"
                            >
                              Agregar Monto
                            </Button>
                            <Button
                              danger
                              onClick={eliminarMontos}
                              disabled={!hasSelectedMontos}
                            >
                              Eliminar
                            </Button>
                          </Space>
                          <span
                            style={{
                              marginLeft: 8
                            }}
                          >
                            {hasSelectedMontos
                              ? `Seleccionados ${selectedRowKeysMonto.length} items`
                              : ''}
                          </span>
                        </div>
                        <Table
                          scroll
                          rowSelection={rowSelectionMonto}
                          style={{ width: 'fit-content' }}
                          bordered
                          dataSource={[...dataMontos]}
                          columns={columnsMontoCuota}
                          pagination={false}
                          rowKey={(record) => record.key || record.id}
                          size="small"
                        />
                      </>
                      <br />
                      <Space>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => onOkMontos()}
                        >
                          Aceptar
                        </Button>
                        <Button
                          htmlType="button"
                          onClick={() => onCancelMontos()}
                        >
                          Cancelar
                        </Button>
                      </Space>
                    </div>
                  )}
                </Form>
              </>
            </div>
          </Modal>
          <Modal
            title="Configurar rango"
            width={700}
            open={modalVisible}
            afterClose={() => modalForm.resetFields()}
            onCancel={() => {
              setModalVisible(false);
            }}
            okButtonProps={{ form: 'tasa_config', htmlType: 'submit' }}
          >
            <Form
              form={modalForm}
              onFinish={onFinishRango}
              scrollToFirstError
              name="tasa_config"
              id="tasa_config"
              autoComplete="off"
              layout="vertical"
            >
              <Row gutter={8}>
                <Col md={12}>
                  <Form.Item
                    label="Desde"
                    name={['monto_min']}
                    rules={[{ required: true }]}
                  >
                    <CurrencyInputCustom
                      readOnly={idActual === 1 && !insertarIntermedio}
                      moneda={monedaSelected}
                      bordered
                      style={{ height: 35.14 }}
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Hasta"
                    name={['monto_max']}
                    dependencies={['monto_min']}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const montoMin = getFieldValue('monto_min');
                          const montoMax = value;
                          if (!montoMax || !montoMin) {
                            return Promise.resolve();
                          }
                          const tasaConfig = form.getFieldValue('tasa_config');
                          if (idActual === tasaConfig[tipoActual].length) {
                            return Promise.resolve();
                          }
                          if (
                            currencyToNumber(montoMin, monedaSelected) >
                            currencyToNumber(montoMax, monedaSelected)
                          ) {
                            return Promise.reject(
                              new Error('Verificar rangos')
                            );
                          }
                          return Promise.resolve();
                        }
                      })
                    ]}
                  >
                    <CurrencyInputCustom
                      moneda={monedaSelected}
                      bordered
                      style={{ height: 35.14 }}
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Nuevo"
                    name={['origen', 'nuevo']}
                    rules={[{ required: true }]}
                    normalize={normalizePorcentaje}
                  >
                    <Input
                      style={{
                        width: 200
                      }}
                      placeholder="0"
                      min={0}
                      max={100}
                      step="any"
                      type="number"
                      suffix="%"
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Representante"
                    name={['origen', 'representante']}
                    rules={[{ required: true }]}
                    normalize={normalizePorcentaje}
                  >
                    <Input
                      style={{
                        width: 200
                      }}
                      placeholder="0"
                      min={0}
                      max={100}
                      step="any"
                      type="number"
                      suffix="%"
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Volante cambiado"
                    name={['origen', 'volantecambiado']}
                    rules={[{ required: true }]}
                    normalize={normalizePorcentaje}
                  >
                    <Input
                      style={{
                        width: 200
                      }}
                      placeholder="0"
                      min={0}
                      max={100}
                      step="any"
                      type="number"
                      suffix="%"
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Importación"
                    name={['origen', 'importacion']}
                    rules={[{ required: true }]}
                    normalize={normalizePorcentaje}
                  >
                    <Input
                      style={{
                        width: 200
                      }}
                      placeholder="0"
                      min={0}
                      max={100}
                      step="any"
                      type="number"
                      suffix="%"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
          <Modal
            title="Configurar costos mínimos"
            width={700}
            open={modalCostosVisible}
            afterClose={() => modalFormCostos.resetFields()}
            onCancel={() => {
              setModalCostosVisible(false);
            }}
            okButtonProps={{
              form: 'costos_minimos_tabla_tasas',
              htmlType: 'submit'
            }}
          >
            <Form
              form={modalFormCostos}
              onFinish={onFinishCostosMinimos}
              scrollToFirstError
              name="costos_minimos_tabla_tasas"
              id="costos_minimos_tabla_tasas"
              autoComplete="off"
              layout="vertical"
            >
              <Row gutter={8}>
                <Col md={12}>
                  <Form.Item
                    label="Nuevo"
                    name={[tipoActual, 'nuevo']}
                    rules={[{ required: true }]}
                    normalize={(value) =>
                      currencyToNumber(value, monedaSelected)
                    }
                  >
                    <CurrencyInputCustom
                      moneda={monedaSelected}
                      autoFocus
                      bordered
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Representante"
                    name={[tipoActual, 'representante']}
                    rules={[{ required: true }]}
                    normalize={(value) =>
                      currencyToNumber(value, monedaSelected)
                    }
                  >
                    <CurrencyInputCustom
                      moneda={monedaSelected}
                      autoFocus
                      bordered
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Volante cambiado"
                    name={[tipoActual, 'volantecambiado']}
                    rules={[{ required: true }]}
                    normalize={(value) =>
                      currencyToNumber(value, monedaSelected)
                    }
                  >
                    <CurrencyInputCustom
                      moneda={monedaSelected}
                      autoFocus
                      bordered
                    />
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Importación"
                    name={[tipoActual, 'importacion']}
                    rules={[{ required: true }]}
                    normalize={(value) =>
                      currencyToNumber(value, monedaSelected)
                    }
                  >
                    <CurrencyInputCustom
                      moneda={monedaSelected}
                      autoFocus
                      bordered
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
          <Modal
            title="Agregar Montos"
            width={700}
            open={formMontosVisible}
            afterClose={() => formMontos.resetFields()}
            onCancel={() => {
              setFormMontosVisible(false);
            }}
            okButtonProps={{ form: 'montos', htmlType: 'submit' }}
          >
            <div>
              <Form
                form={formMontos}
                onFinish={onFinishMontos}
                scrollToFirstError
                name="montos"
                id="montos"
                autoComplete="off"
                layout="vertical"
              >
                <Row gutter={8}>
                  <Col md={12}>
                    <Form.Item
                      label="Vigencia"
                      name="id_vigencia_pago"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        style={{ width: '100%' }}
                        optionFilterProp="children"
                        placeholder="Elegir vigencia"
                        onChange={(value) => {
                          formMontos.setFieldsValue({
                            id_vigencia_pago: value
                          });
                        }}
                      >
                        {vigencias.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col md={12}>
                    <Form.Item
                      label="Monto"
                      name="monto_cuota"
                      rules={[{ required: true }]}
                      normalize={(value) =>
                        currencyToNumber(value, monedaSelected)
                      }
                    >
                      <CurrencyInputCustom
                        moneda={monedaSelected}
                        autoFocus
                        bordered
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col md={12}>
                    <Form.Item
                      label="Cantidad de Cuotas"
                      name="numero_cuotas"
                      rules={[{ required: true }]}
                    >
                      <InputNumber />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          </Modal>
          <Modal
            title="Configuración de parámetros de Productos - Sistema Core"
            width={600}
            open={parametrosVisible}
            onCancel={() => {
              formParametros.resetFields();
              setParametrosVisible(false);
            }}
            okButtonProps={{
              form: 'json_producto_sistema_core',
              htmlType: 'submit'
            }}
          >
            <Form
              form={formParametros}
              onFinish={onFinishParametrosProducto}
              scrollToFirstError
              name="json_producto_sistema_core"
              id="json_producto_sistema_core"
              autoComplete="off"
              layout="vertical"
            >
              <Row gutter={8}>
                <Col md={12}>
                  <Form.Item label="Producto" name="producto">
                    <Select
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(value) => {
                        formParametros.setFieldsValue({
                          producto: value
                        });
                      }}
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Seleccionar Producto de Sebaot"
                    >
                      {productos.map((itemProducto) => (
                        <Option
                          key={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                          value={`${itemProducto.codigo}-${itemProducto.codigo_seccion}`}
                        >
                          {`${itemProducto.codigo} - ${itemProducto.codigo_seccion} - ${itemProducto.descripcion}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Objeto" name="objeto">
                    <Select
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(value) => {
                        formParametros.setFieldsValue({
                          objeto: value
                        });
                      }}
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Seleccionar Objeto de Sebaot"
                    >
                      {objetos.map((itemRiesgo) => (
                        <Option
                          key={itemRiesgo.codigo}
                          value={`${itemRiesgo.codigo}`}
                        >
                          {`${itemRiesgo.codigo} - ${itemRiesgo.descripcion}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label="Riesgo" name="riesgo">
                    <Select
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(value) => {
                        formParametros.setFieldsValue({
                          riesgo: value
                        });
                      }}
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Seleccionar Riesgo de Sebaot"
                    >
                      {' '}
                      {riesgos.map((itemRiesgo) => (
                        <Option
                          key={itemRiesgo.codigo}
                          value={`${itemRiesgo.codigo}`}
                        >
                          {`${itemRiesgo.codigo} - ${itemRiesgo.descripcion}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Tipo Riesgo" name="tipo_riesgo">
                    <Select
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(value) => {
                        formParametros.setFieldsValue({
                          tipo_riesgo: value
                        });
                      }}
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Seleccionar Tipo de Riesgo"
                    >
                      {tiposRiesgo.map((itemTipo) => (
                        <Option
                          key={itemTipo.codigo}
                          value={`${itemTipo.codigo}`}
                        >
                          {`${itemTipo.codigo} - ${itemTipo.descripcion}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        </>
      )}
    </>
  );
};

export const PlanConfigControles = ({ onOk, plan = {}, disabled }) => {
  const [loading, setLoading] = useState(false);
  const [openPlanConfigEditor, setOpenPlanConfigEditor] = useState(false);

  if (plan?.controles) {
    for (let index = 0; index < plan.controles.length; index += 1) {
      const control = plan.controles[index];
      control.tipo_validacion = getTipoValidacion(control);
    }
  }

  const onFinish = (values) => {
    onOk({
      ...plan,
      controles: [...values]
    });
  };

  const handleClick = async () => {
    setOpenPlanConfigEditor(true);
  };

  return (
    <>
      {plan && (
        <>
          <FilterOutlined
            disabled={disabled}
            onClick={handleClick}
            style={{
              color:
                plan?.controles?.filter(({ eliminado }) => !eliminado).length >
                0
                  ? CONFIG.COLOR_PRIMARY
                  : 'rgba(0,0,0,.45)'
            }}
          />
          <PlanControlProductoModal
            open={openPlanConfigEditor}
            setOpen={(value) => setOpenPlanConfigEditor(value)}
            esVehiculo={plan.producto.codigo === 1}
            idAutorizacionConfig={plan.id}
            controlProductoList={plan.controles}
            setControlProductoList={onFinish}
            loading={loading}
            setLoading={setLoading}
            mostrarAcciones={false}
            moneda={plan.moneda}
            producto={plan.producto.codigo}
          />
        </>
      )}
    </>
  );
};

export const PlanCoberturaItemConfig = ({
  open,
  onCancel,
  onOk,
  model = {},
  idAseguradora,
  moneda
}) => {
  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState([]);
  const [franquiciaObject, setFranquiciaObject] = useState();

  const prepareData = (values) => {
    const preparedData = {
      ...values,
      franquicia_opcion:
        values.franquicia_opcion === '' ? null : values.franquicia_opcion,
      ...(values.franquicia_monto
        ? {
            franquicia_monto: Number(values.franquicia_monto || '0')
          }
        : {}),
      ...(values.franquicia_costo_min
        ? {
            franquicia_costo_min: Number(values.franquicia_costo_min || '0')
          }
        : {}),
      ...(values.franquicia_costo_max
        ? {
            franquicia_costo_max: Number(values.franquicia_costo_max || '0')
          }
        : {})
    };

    const descripcion = getDescripcionFranquicia(preparedData, moneda);
    return {
      ...preparedData,
      franquicia_descripcion: descripcion,
      franquicia_config: franquiciaObject?.data
    };
  };
  const onFinish = (values) => {
    onOk(prepareData(values));
  };

  const mapOptions = (data) => ({
    value: data.parcial_franquicia,
    label: `(${data.parcial_franquicia}) ${
      data.tipo_franquicia === 'F'
        ? formatoMonedaGenerico(moneda, data.franquicia || '0')
        : data.franquicia + data.descripcion
    }`,
    data
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchList = () => {
    return instanceRef.instance.get(`/sebaot/franquicias`, {
      params: { idAseguradora, codigo_producto: model.producto?.codigo, model }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    if (form && model.producto?.codigo) {
      const loadData = async () => {
        setLoading(true);
        try {
          const response = await fetchList();
          setLoading(false);
          if (response.data.data) {
            setOptions(response.data.data.map(mapOptions));
          } else {
            message.error('No se pudo cargar la lista de franquicias');
          }
        } catch (error) {
          setLoading(false);
          errorHandler(error);
        }
      };
      setFranquiciaObject(model.franquicia_config);
      form.setFieldsValue({
        ...model,
        franquicia_config: !isEmpty(model.franquicia_config)
          ? model.franquicia_config
          : undefined,
        franquicia_opcion:
          model.franquicia_opcion === null ? '' : model.franquicia_opcion,
        franquicia_criterio: model.franquicia_criterio || '0',
        franquicia_monto: `${model.franquicia_monto}` || '0',
        franquicia_costo_min: `${model.franquicia_costo_min}` || '0',
        franquicia_costo_max: `${model.franquicia_costo_max}` || '0'
      });
      if (model.producto?.codigo) {
        loadData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, model]);

  return (
    <>
      {model && (
        <Modal
          forceRender
          title="Configuración de Franquicia"
          open={open}
          destroyOnClose
          afterClose={() => form.resetFields()}
          onCancel={() => {
            onCancel();
          }}
          okButtonProps={{
            form: 'planCoberturaItemEditor',
            htmlType: 'submit'
          }}
        >
          <div style={{ textAlign: 'left' }}>
            <>
              <Form
                {...formDialogLayout}
                scrollToFirstError
                form={form}
                id="planCoberturaItemEditor"
                name="planCoberturaItemEditor"
                autoComplete="off"
                layout="horizontal"
                onFinish={onFinish}
              >
                <Form.Item name="franquicia_opcion" label="Franquicia">
                  <Radio.Group>
                    <Space direction="vertical">
                      <Radio value="">Sin Franquicia</Radio>
                      <Radio value="monto_fijo">Monto Fijo</Radio>
                      <Radio value="valor_siniestro">Sobre Siniestro</Radio>
                      <Radio value="suma_asegurada">Sobre Suma Asegurada</Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues.franquicia_opcion !== curValues.franquicia_opcion
                  }
                >
                  {({ getFieldValue }) => {
                    return (
                      <>
                        {getFieldValue('franquicia_opcion') ===
                          'monto_fijo' && (
                          <Form.Item
                            label="Monto"
                            name="franquicia_monto"
                            normalize={(value) =>
                              currencyToNumber(value, moneda)
                            }
                          >
                            <CurrencyInputCustom moneda={moneda} bordered />
                          </Form.Item>
                        )}
                        {(getFieldValue('franquicia_opcion') ===
                          'valor_siniestro' ||
                          getFieldValue('franquicia_opcion') ===
                            'suma_asegurada') && (
                          <Form.Item
                            label="Porcentaje"
                            name="franquicia_criterio"
                          >
                            <InputNumber
                              min={0}
                              max={100}
                              formatter={(value) => `${value}%`}
                              parser={(value) => value.replace('%', '')}
                              decimalSeparator=","
                            />
                          </Form.Item>
                        )}
                        {(getFieldValue('franquicia_opcion') ===
                          'valor_siniestro' ||
                          getFieldValue('franquicia_opcion') ===
                            'suma_asegurada') && (
                          <>
                            <Form.Item
                              label="Mínimo"
                              name="franquicia_costo_min"
                              normalize={(value) =>
                                currencyToNumber(value, moneda)
                              }
                            >
                              <CurrencyInputCustom moneda={moneda} bordered />
                            </Form.Item>
                            <Form.Item
                              label="Máximo"
                              name="franquicia_costo_max"
                              normalize={(value) =>
                                currencyToNumber(value, moneda)
                              }
                            >
                              <CurrencyInputCustom moneda={moneda} bordered />
                            </Form.Item>
                          </>
                        )}
                      </>
                    );
                  }}
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues.franquicia_opcion !==
                      curValues.franquicia_opcion ||
                    prevValues.franquicia_monto !==
                      curValues.franquicia_monto ||
                    prevValues.franquicia_costo_min !==
                      curValues.franquicia_costo_min ||
                    prevValues.franquicia_costo_max !==
                      curValues.franquicia_costo_max ||
                    prevValues.franquicia_criterio !==
                      curValues.franquicia_criterio
                  }
                >
                  {({ getFieldValue }) => {
                    return (
                      <>
                        {getFieldValue('franquicia_opcion') !== '' && (
                          <>
                            <Form.Item
                              label="Descripción"
                              name="franquicia_descripcion"
                            >
                              <span>
                                {getDescripcionFranquicia(
                                  prepareData(getFieldValue()),
                                  moneda
                                )}
                              </span>
                            </Form.Item>
                            <Form.Item
                              label="Franquicia Sistema Core"
                              name="franquicia_config"
                            >
                              <FranquiciaSelect
                                loading={loading}
                                options={options}
                                onSelect={(option) => {
                                  let franquicia = options.find(
                                    (item) => item.value === option.value
                                  );
                                  franquicia = lodashClonedeep(franquicia);
                                  setFranquiciaObject(franquicia);
                                }}
                              />
                            </Form.Item>
                          </>
                        )}
                      </>
                    );
                  }}
                </Form.Item>
              </Form>
            </>
          </div>
        </Modal>
      )}
    </>
  );
};

export const PlanCoberturaItemMinMaxConfig = ({
  open,
  onCancel,
  onOk,
  model = {},
  moneda
}) => {
  const [form] = Form.useForm();
  const [textMax, setTextMax] = useState();
  const [textMin, setTextMin] = useState();
  const [monto_max, setMonto_max] = useState();
  const [monto_min, setMonto_min] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const onFinish = (values) => {
    const newModel = model;

    newModel.monto_max = values.monto_max
      ? currencyToNumber(values.monto_max, moneda)
      : null;
    newModel.monto_min = values.monto_min
      ? currencyToNumber(values.monto_min, moneda)
      : null;
    onOk(newModel);
  };

  const handleFormChange = (field, value) => {
    form.setFieldsValue({
      [field]: value
    });
  };

  const debounceFormChange = (field, monto) => {
    const montoNumerico = currencyToNumber(monto, moneda);
    let aux = true;
    if (montoNumerico < monto_min && monto_min) {
      handleFormChange(field, monto_min);
      aux = false;
    }
    if (montoNumerico > monto_max && monto_max) {
      handleFormChange(field, monto_max);
      aux = false;
    }
    if (aux) {
      if (field === 'monto_max') {
        handleFormChange(field, monto);
      } else {
        handleFormChange(field, monto);
      }
    }
  };

  const minMaxValidator = (min, max) => {
    return !(
      min &&
      max &&
      currencyToNumber(min, moneda) > currencyToNumber(max, moneda)
    );
  };

  useEffect(() => {
    if (form && Object.keys(model).length > 0) {
      form.setFieldsValue({
        monto_max: model.monto_max
          ? numberToCurrency(model.monto_max, moneda)
          : '',
        monto_min: model.monto_min
          ? numberToCurrency(model.monto_min, moneda)
          : ''
      });
      if (Object.keys(model).length > 0) {
        if (model.subcobertura.monto_min) {
          setMonto_min(model.subcobertura.monto_min);
          setTextMin(
            `El monto mínimo permitido es de ${formatoMonedaGenerico(
              moneda.codigo,
              model.cobertura.monto_min
            )}`
          );
        }
        if (model.subcobertura.monto_max) {
          setMonto_max(model.subcobertura.monto_max);
          setTextMax(
            `El monto máximo permitido es de ${formatoMonedaGenerico(
              moneda.codigo,
              model.subcobertura.monto_max
            )}`
          );
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, model]);
  return (
    <>
      {Object.keys(model).length > 0 && (
        <Modal
          forceRender
          title="Configuración de Monto Mínimo y Máximo"
          open={open}
          destroyOnClose
          afterClose={() => {
            form.resetFields();
            setMonto_max();
            setMonto_min();
            setTextMax();
            setTextMin();
          }}
          onCancel={() => {
            onCancel();
          }}
          okButtonProps={{
            form: 'planCoberturaItemMinMaxEditor',
            htmlType: 'submit',
            disabled: isDisabled
          }}
        >
          <div style={{ textAlign: 'left' }}>
            <>
              <Form
                {...formDialogLayout}
                scrollToFirstError
                form={form}
                id="planCoberturaItemMinMaxEditor"
                name="planCoberturaItemMinMaxEditor"
                autoComplete="off"
                layout="horizontal"
                initialValues={{ monto_max: '', monto_min: '' }}
                onFinish={onFinish}
                onValuesChange={(_, values) => {
                  setIsDisabled(
                    !minMaxValidator(values.monto_min, values.monto_max)
                  );
                }}
              >
                <Form.Item label="Monto Máximo" name="monto_max">
                  <CurrencyInputCustom
                    moneda={moneda}
                    onChange={(e) => {
                      debounceFormChange('monto_max', e);
                    }}
                    bordered
                  />
                </Form.Item>
                <Form.Item
                  label="Monto Mínimo"
                  name="monto_min"
                  dependencies={['monto_max']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const max = getFieldValue('monto_max');
                        if (minMaxValidator(value, max)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'El monto máximo no puede ser menor al mínimo'
                          )
                        );
                      }
                    })
                  ]}
                >
                  <CurrencyInputCustom
                    moneda={moneda}
                    onChange={(e) => {
                      debounceFormChange('monto_min', e);
                    }}
                    bordered
                  />
                </Form.Item>
                {textMin && <Text>*{textMin}</Text>}
                {textMin && textMax && <br />}
                {textMax && <Text>*{textMax}</Text>}
              </Form>
            </>
          </div>
        </Modal>
      )}
    </>
  );
};
